export default {
  'Hot Showcase': '热点图管理',
  'Add Hotspot': '添加热点',
  'Scene Image': '场景图片',
  'Hotspot Amount': '热点数量',
  'Binding Product': '关联展品',
  'Hotspot Created Date': '日期',
  'On Stage': '已推荐',
  'Not On Stage': '未推荐',
  'Expand': '展开',
  'Collapes': '收起',
  'Set hotspot and combine products': '设置热点并关联展品',
  'Hotspot Upload Image': '上传图片',
  'Combine products': '关联展品',
  'Combine products description': '关联展品是您参加线上展上传的展品，如果没有展品，请前往编辑展品页面',
  'Hotspot Upload Tips': '注意：尺寸不低于1000*560像素，支持png、jpg格式，不超过2Mb，您最多可上传一张场景图',
  'Previous Step': '上一步',
  'Next Step': '下一步',
  'Set hotspots and go to product detail.': '设置热点 跳转展品',
  'Set hotspots': '设置热点',
  'Hotspot tips2': '注意：点击图片任意位置添加热点，拖动可改变热点位置，最少添加1个，最多添加10个。',
  'You can only add the hotspot up to 10': '您最多可添加10个热点',
  'Please enter product name for searching': '请输入展品名称搜索',
  'Please select a product': '请选择展品',
  'Hotspot position': '热点位置',
  'Hotspot': '热点',
  'Update combined product': '更新关联展品',
  'Are you sure you want to delete this hotspot?': '确定删除此热点图吗？',
  'Hosspot Image': '热点图片'
}